module.exports = __webpack_public_path__ + "img/Invasion-GBM_GSE194329.cf0fc8fc.png";